import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconFolderSectionsConnectedSizeS from './IconFolderSectionsConnected_size_s';

const props: CreateIconArguments = {
  l: IconFolderSectionsConnectedSizeS,
  m: IconFolderSectionsConnectedSizeS,
  s: IconFolderSectionsConnectedSizeS,
  xs: IconFolderSectionsConnectedSizeS,
  name: 'IconFolderSectionsConnected',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
